<template>
  <div>
    <div v-if="occurrences.length">
      <div class="flex flex-col gap-4">
        <div
          class="p-4"
          style="
            border-style: solid;
            border-radius: 1rem;
            border-width: 0.2rem;
            border-color: rgb(217, 217, 217);
          "
          v-for="(item, index) in occurrences"
          :key="index"
        >
          <span class="text-sm font-semibold"
            >{{ occurrencyTitle(item.date) }} - {{ item.user }}</span
          >
          <p
            class="mt-2 text-base pl-0 ql-editor"
            v-html="DOMPurify.sanitize(item.description)"
          ></p>
          <p
            v-if="showAttachmentsLabel(item.attachments)"
            class="mt-2 font-semibold"
          >
            Anexos
          </p>
          <div class="flex flex-row flex-wrap">
            <span
              class="mt-2 mb-2 mr-8"
              v-for="(attchment, indexAttchment) in item.attachments"
              :key="indexAttchment"
            >
              <a
                :href="attchment.url"
                target="_blank"
                rel="noopener noreferrer"
                @click.prevent="openFile(attchment.url)"
                ><vs-icon
                  class="icon-spacing mr-1"
                  icon-pack="feather"
                  color="rgb(117,117,117)"
                  icon="icon-download"
                ></vs-icon>
                {{ attchment.file }}</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <vs-alert style="height: auto" active="true">
        Nenhuma Ocorrência Encontrada
      </vs-alert>
    </div>
  </div>
</template>

<script>
import DOMPurify from 'dompurify';
import functions from '../../utils/functions';

export default {
  name: 'ListOccurrences',

  props: ['occurrences'],

  data() {
    return {
      DOMPurify,
    };
  },

  methods: {
    openFile(link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    },
    occurrencyTitle(date) {
      return functions.formatDateAndHour(date, true);
    },
    showAttachmentsLabel(attachment) {
      return Array.isArray(attachment) && attachment.length;
    },
  },
};
</script>
